import React from "react";
import routerProvider from "@pankod/refine-react-router-v6";
import { TitleProps } from "@pankod/refine-core";

const { Link } = routerProvider;

export const Title: React.FC<TitleProps> = ({ collapsed }) => (
  <Link to="/">
    {collapsed ? (
      <img
        src={"/logo-collapsed.svg"}
        alt="Solar manager"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
//          padding: "12px 24px",
        }}
      />
    ) : (
      <img
        src={"/logo.svg"}
        alt="Solar manager"
        style={{
          width: "200px",
          padding: "12px 24px",
        }}
      />
    )}
  </Link>
);
